import React, { memo } from 'react';
import { XIcon } from '@fronton/icons-react';
import { ModalContent, Portal } from 'fronton-react';
import { createElementKey } from 'utils';
import { ButtonWithGAClickButton } from '../../../../button';
import { Modal } from '../../../../modal';
import { Typography } from '../../../../typography';
import {
  closeIcon,
  mobilePanelDescription,
  mobilePanelIcon,
  mobilePanelModal,
  mobilePanelModalActions,
  mobilePanelModalContent,
} from './mobile-fixed-panel-modal-styles';
import { MobileFixedPanelStructure, PanelActionBlock } from '../mobile-fixed-panel-types';

type MobileFixedPanelProps = {
  elementName?: string;
  structure: MobileFixedPanelStructure;
  isOpen: boolean;
  onClose: () => void;
};

export const MobileFixedPanelModal: React.FC<MobileFixedPanelProps> = memo(({ elementName, isOpen, onClose, structure }) => {
  const MobilePanelIcon = structure.content.icon;
  const mobileElementName = elementName || 'sticky-panel-mobile / modal';

  return (
    <Portal>
      <Modal
        className={mobilePanelModal}
        onClose={onClose}
        closeButton={false}
        overlayType="medium"
        show={isOpen}
        size="l"
        variant="curtain">
        <ModalContent className={mobilePanelModalContent}>
          <XIcon
            className={closeIcon}
            color="text-minor"
            onClick={onClose}
            type="outline"
            size="m"
            strokeWidth={2}
          />

          <MobilePanelIcon
            className={mobilePanelIcon}
            color={structure.content.iconColor}
            size="xxl"
            strokeWidth={0.5}
            type={structure.content.iconType}
          />
          <Typography
            adaptive={false}
            className={mobilePanelDescription}
            color="text-invert"
            size="body_short"
            variant="m">
            {structure.content.text}
          </Typography>

          <div className={mobilePanelModalActions}>
            {structure.actionBlock.map(({ label, onClick, ...btnProps }, index: number) => (
              <ButtonWithGAClickButton
                adaptive={false}
                aria-label={label}
                elementName={mobileElementName}
                elementText={label}
                key={createElementKey('fixed-panel-btn', index)}
                onClick={onClick}
                title={label}
                wide
                {...(btnProps as Omit<PanelActionBlock, 'label' | 'onClick'>)}>
                {label}
              </ButtonWithGAClickButton>
            ))}
          </div>
        </ModalContent>
      </Modal>
    </Portal>
  );
});
